import * as h2h from './h2h';
import * as user from './user';
import * as admin from './admin';
import * as crm from './crm';
import * as note from './note';
import * as habit from './habit';
import * as course from './course';
import * as behavior from './behavior';
import * as cohort from './cohort';
import * as systemBanner from './systemBanner';

export const userAPI = user;
export const adminAPI = admin;
export const crmAPI = crm;
export const noteAPI = note;
export const habitAPI = habit;
export const courseAPI = course;
export const behaviorAPI = behavior;
export const h2hAPI = h2h;
export const cohortAPI = cohort;
export const systemBannerAPI = systemBanner;
